import React from "react";

const CptDashboardSkeletonOverlay = ({ children }) => (
  <div className="cpt-dash-skeleton-overlay" aria-hidden="true">
    {children}
  </div>
);

export default CptDashboardSkeletonOverlay;
